import { useEffect, useState } from "react";

const PHONE_MAX_SIZE = 670;
const PAD_MAX_SIZE = 820;

export const useCurrentDevice = (): {
  isComp: boolean;
  isPad: boolean;
  isPhone: boolean;
} => {
  const getIsPhone = () => screen.width <= PHONE_MAX_SIZE;
  const getIsPad = () =>
    PHONE_MAX_SIZE < screen.width && screen.width <= PAD_MAX_SIZE;
  const getIsComp = () => PAD_MAX_SIZE < screen.width;

  const [isPhone, setIsPhone] = useState(getIsPhone);
  const [isPad, setIsPad] = useState(getIsPad);
  const [isComp, setIsComp] = useState(getIsComp);

  useEffect(() => {
    const setSize = () => {
      setIsPhone(getIsPhone());
      setIsPad(getIsPad());
      setIsComp(getIsComp());
    };

    // Set the initial value based on the current screen width
    setSize();

    window.addEventListener("resize", setSize);
    return () => window.removeEventListener("resize", setSize);
  }, []);

  return { isPad, isPhone, isComp };
};
